import { render } from "./J05ChatScreenPanel.vue?vue&type=template&id=61e843d4&scoped=true&ts=true"
import script from "./J05ChatScreenPanel.vue?vue&type=script&lang=ts"
export * from "./J05ChatScreenPanel.vue?vue&type=script&lang=ts"

import "./J05ChatScreenPanel.vue?vue&type=style&index=0&id=61e843d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e843d4"]])

export default __exports__